import type { OpeningType, SourceCalculationCapability } from "./types";

export function sourceOpeningsForHardware(source:SourceCalculationCapability|undefined|null,hardware:string) {
  if(source?.engine==="itokna-system-29")return source.openings;
  const selected=hardware==="Без фурнитуры"?source?.hardware:hardware;
  return source?.hardwareKits?.find(kit=>kit.name===selected)?.openings??source?.openings;
}

// Adding a sash to a fixed control must restore the actual kit of its selected
// source system, not keep the fixed sample's "Без фурнитуры" value.
export function sourceHardwareForOpenings(source: SourceCalculationCapability | undefined | null, openings: OpeningType[], current: string) {
  if (!source?.available) return current;
  const count = openings.filter(o => o !== "Fixed").length;
  if (!count) return "Без фурнитуры";
  if (source.engine === "itokna-system-29")
    return source.hardwareOptions?.find(kit=>kit!=="Без фурнитуры") ?? current;
  return source.hardwareOptions?.includes(current) ? current : source.hardware;
}
